(function () {
  /* ---------- Helpers ---------- */

  function stripHtml(html) {
    return String(html).replace(/<[^>]*>/g, "");
  }

  function formatMoneyPlain(cents) {
    try {
      if (window.Shopify && typeof window.Shopify.formatMoney === "function") {
        const fmt =
          window.money_format ||
          window.theme?.moneyFormat ||
          window.Shopify.money_format ||
          "${{amount}}";

        // Shopify.formatMoney may return HTML → strip it
        return stripHtml(window.Shopify.formatMoney(cents, fmt));
      }
    } catch (e) {}

    return `$${(cents / 100).toFixed(2)}`;
  }

  function updateHeaderCart(cart) {
    /* ---------- COUNT ---------- */
    document.querySelectorAll("[data-cart-button-count]").forEach((el) => {
      el.textContent = String(cart.item_count);
    });

    /* ---------- TOTAL ---------- */
    const totalText = formatMoneyPlain(cart.total_price);

    document.querySelectorAll("[data-cart-button-total]").forEach((el) => {
      // Always render clean HTML for Transcy
      el.innerHTML = `<span class="transcy-money">${totalText}</span>`;
    });

    /* ---------- Currency refresh (safe if not present) ---------- */
    try {
      document.dispatchEvent(new Event("transcy:refresh"));
      document.dispatchEvent(new Event("currency:refresh"));
      document.dispatchEvent(new Event("currency:convert"));
      window.Transcy?.reload?.();
      window.transcy?.reload?.();
    } catch (e) {}
  }

  async function refreshCart() {
    try {
      const cart = await fetch("/cart.js", { credentials: "same-origin" }).then((r) =>
        r.json()
      );
      updateHeaderCart(cart);
    } catch (e) {}
  }

  function isCartUrl(url) {
    if (!url) return false;
    const u = String(url);
    return (
      u.includes("/cart/add") ||
      u.includes("/cart/change") ||
      u.includes("/cart/update") ||
      u.includes("/cart/clear") ||
      u.includes("/cart.js")
    );
  }

  /* ---------- Hook FETCH (most apps) ---------- */
  const _fetch = window.fetch;
  window.fetch = function (...args) {
    const url = args[0];
    const watch = isCartUrl(url);

    return _fetch.apply(this, args).then((res) => {
      if (watch) setTimeout(refreshCart, 250);
      return res;
    });
  };

  /* ---------- Hook XHR (older / some apps) ---------- */
  const _open = XMLHttpRequest.prototype.open;
  const _send = XMLHttpRequest.prototype.send;

  XMLHttpRequest.prototype.open = function (method, url, ...rest) {
    this.__watchCart = isCartUrl(url);
    return _open.call(this, method, url, ...rest);
  };

  XMLHttpRequest.prototype.send = function (...args) {
    this.addEventListener("load", () => {
      if (this.__watchCart) setTimeout(refreshCart, 250);
    });
    return _send.apply(this, args);
  };

  /* ---------- Initial sync ---------- */
  document.addEventListener("DOMContentLoaded", refreshCart);
})();
